/**
 * Design tokens for the Wizzy 2.5 migration modal (Migration Modal.dc.html).
 */
import { BRAND_GRADIENT, BRAND_GRADIENT_STOPS } from "@/utils/brandStyles";

export const MIGRATION_MODAL_GRADIENT = BRAND_GRADIENT;

export const MIGRATION_MODAL_GRADIENT_COLORS = {
  from: BRAND_GRADIENT_STOPS.from,
  to: BRAND_GRADIENT_STOPS.to,
  deg: BRAND_GRADIENT_STOPS.deg,
} as const;

export const MIGRATION_MODAL_GRADIENT_ID = "migration-modal-brand-gradient";

/** Sunset + continuity messaging for the migration page and legacy banner.
 *
 * Names the date. "Ahead of tax season" is not a deadline anyone can plan
 * around — a pro reads it as "sometime, not now" and puts the decision off,
 * which is exactly the outcome the sunset exists to prevent. */
export const MIGRATION_CALLOUT_COPY =
  "The current organizer stops being supported after 30 September 2026. Your clients and data come with you — Wizzy 2.5 has you covered.";

/** Footer note clarifying the reversible choice window before sunset. */
export const MIGRATION_FOOTER_COPY =
  "You can switch back any time before 30 September. This applies to your team and clients, too.";

/** Brand label highlighted in the legacy migration reminder. */
export const MIGRATION_BANNER_BRAND_LABEL = "Wizzy 2.5";

/** Supporting copy for the dismissible legacy migration reminder. */
export const MIGRATION_BANNER_SUBTITLE =
  "Takes a minute — nothing to migrate by hand.";
